import type { ReactNode } from 'react';

export function Modal(props: { title: string; onClose: () => void; children: ReactNode; wide?: boolean }) {
  return (
    <div className="modal-backdrop" onMouseDown={props.onClose}>
      <div className={`modal ${props.wide ? 'wide' : ''}`} onMouseDown={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h2>{props.title}</h2>
          <button className="link" onClick={props.onClose} aria-label="Închide">✕</button>
        </div>
        {props.children}
      </div>
    </div>
  );
}

export function ErrorMsg({ error }: { error: string | null }) {
  return error ? <p className="error">{error}</p> : null;
}
